export function removeCircularReferences<T>(obj: T): T {
  const seen = new WeakSet<object>();

  function detectCycles(value: any): any {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return undefined;
      }
      seen.add(value);

      if (Array.isArray(value)) {
        return value.map((item) => detectCycles(item));
      } else {
        const result: Record<string, any> = {};
        for (const key in value) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            result[key] = detectCycles(value[key]);
          }
        }
        return result;
      }
    } else {
      return value;
    }
  }

  return detectCycles(obj);
}
